import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { selectLockedAccountTimeStamp } from 'src/app/ngrx/auth/auth.selectors';
import { LoginMultipleIncorrectAttemptsDialogContentComponent } from '../components/login-multiple-incorrect-attempts-dialog-content/login-multiple-incorrect-attempts-dialog-content.component';

@Injectable({
  providedIn: 'root',
})
export class LockedAccountGuard implements CanActivate, CanActivateChild {
  constructor(private store$: Store, private dialog: MatDialog, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store$.pipe(
      select(selectLockedAccountTimeStamp),
      map((lockedAccountTimeStamp) => {
        let openedDialog: boolean = !!this.dialog.openDialogs?.length;

        if (lockedAccountTimeStamp) {
          // open dialog if it's not already opened
          if (!openedDialog) {
            this.dialog.open(LoginMultipleIncorrectAttemptsDialogContentComponent, { disableClose: true });
          }

          // block user's navigating to auth pages and route him to login page unless he's in login page
          if (state.url !== '/login') {
            this.router.navigate(['/login']);
            return false;
          }
        }
        return true;
      })
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
